import React, { useEffect } from 'react';
import { Container } from 'reactstrap';
import { useHomeContext } from '../../contexts/HomeContext';
import HelpBlock from './components/HelpBlock';
import { Banner, BannerText, BannerTitle, BannerDescription, BannerContainer } from './style';
import SignInOrchestration from './components/SignInOrchestration';
import FinancingSolutionsMenu from './components/FinancingSolutionsMenu';
import FinancingSolutions from './components/FinancingSolutions';
import Chat from '../../components/Chat';
import { createSafeHtml } from '../../utils/sanitizeHtml';

const LoginPilot = () => {
  const { banner, modules } = useHomeContext();

  useEffect(() => {
    document.title = 'Dell Financial Services';
  });

  return (
    <>
      <Chat />
      <Banner image={banner.bannerUrl}>
        <BannerContainer>
          <BannerText>
            <BannerDescription>{banner.title}</BannerDescription>
            <BannerTitle dangerouslySetInnerHTML={createSafeHtml(banner.description)} />
          </BannerText>
          <SignInOrchestration />
        </BannerContainer>
      </Banner>
      <FinancingSolutionsMenu financingSolutions={modules} />
      <Container className="container-fluid container-xl">
        <FinancingSolutions financingSolutions={modules} />
        <HelpBlock />
      </Container>
    </>
  );
};


export default LoginPilot;